module.exports = __webpack_public_path__ + "static/media/_black_white_2.efeb9443.jpeg";